import Span from "@/js/common/ui/Span";
import AdminMenu from "@/js/system/common/SystemMenu";
import { useLocation } from "react-router-dom";
import { Fragment } from "react/jsx-runtime";
import Button from "@/js/common/ui/Button";
import { useNavigate } from "react-router-dom";

const Header = () => {
    const location = useLocation();
    const navigate = useNavigate();

    const detailMenuName = AdminMenu.getAdminSubMenuDetailName(location.pathname);

    const removeBr = (node: any): any => {  // br 태그 제거
        if (typeof node === "string") return node;
        if (Array.isArray(node)) return node.map(removeBr);
        if (node?.type === "br") return " ";

        return node?.props?.children
            ? { ...node, props: { ...node.props, children: removeBr(node.props.children) } }
            : node;
    };

    return (
        <div style={{borderBottom: "1px solid #dbdbdb", paddingBottom: "5px"}}>
            <Span fontSize={13} color="#222" letterSpacing={-1} className="dpFlx aiC">
                <Span fontFamily="Pretendard-Regular" style={{marginRight: 5}}>
                    홈
                </Span>
                {">"}
                <Button onClickFunc={() => navigate(AdminMenu.getAdminMenuPath(location.pathname))}>
                    <Span fontFamily="Pretendard-Regular" style={{marginLeft: 5, marginRight: 5}}>
                        {AdminMenu.getAdminMenuName(location.pathname)}
                    </Span>
                </Button>
                {">"}
                <Button onClickFunc={() => navigate(AdminMenu.getAdminSubMenuPath(location.pathname))}>
                    <Span fontFamily={detailMenuName ? "Pretendard-Regular" : "Pretendard-Semibold"} style={{marginLeft: 5, marginRight: 5, whiteSpace: "nowrap"}}>
                        {removeBr(AdminMenu.getAdminSubMenuName(location.pathname))}
                    </Span>
                </Button>
                {detailMenuName !== "" &&
                    <Fragment>
                        {">"}
                        <Span fontFamily="Pretendard-Semibold" style={{marginLeft: 5}}>
                            {detailMenuName}
                        </Span>
                    </Fragment>
                }
            </Span>
        </div>
    )
}
export default Header;